//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios';
import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import FeedbackForm from '../FeedbackForm.vue';
import jquery from 'jquery';
export default {
	name: 'PageContacts',

	components: { PageBanner: PageBanner, PageLimiter: PageLimiter, Breadcrumbs: Breadcrumbs, FeedbackForm: FeedbackForm, jquery: jquery },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		defaultDomain: {
			type: Object,
			default: function _default() {
				return {};
			}
		}

	},
	data: function data() {
		return {
			selectedCity: 'test3.rbru.ru',
			Ymap: {}
		};
	},
	mounted: function mounted() {
		var _this = this;

		jquery.getScript('//api-maps.yandex.ru/2.1/?lang=ru_RU').then(function () {
			var ymaps = global.ymaps;
			ymaps.ready(function () {
				_this.Ymap = new ymaps.Map("map", {
					center: _this.currentCordinates.cordinates,
					zoom: 12
				});
				var myPlacemark = new ymaps.Placemark(_this.currentCordinates.cordinates, {
					hintContent: _this.currentCordinates.adress,
					balloonContent: _this.currentCordinates.adress
				});
				_this.Ymap.geoObjects.add(myPlacemark);
			});
		});
	},

	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		feedback: function feedback() {
			return this.$store.state.settings.feedbackTile.form || {};
		},
		test: function test() {
			return this.$store.state.settings || {};
		},
		domains: function domains() {
			return this.$store.state.settings.domains || {};
		},
		currentDomain: function currentDomain() {
			if (process.browser) {
				var host = location.host;
			}
			var domains = this.domains;
			var cd = this.defaultDomain;
			for (var i in domains) {
				if (domains[i].host == host) {
					cd = domains[i];
				}
			}
			return cd;
		},
		currentCordinates: function currentCordinates() {
			return this.getDomain(this.selectedCity);
		}
	},
	methods: {
		changeCordinates: function changeCordinates() {
			var ymaps = global.ymaps;
			this.Ymap.geoObjects.removeAll();
			this.Ymap.setCenter(this.currentCordinates.cordinates);
			var myPlacemark = new ymaps.Placemark(this.currentCordinates.cordinates, {
				hintContent: this.currentCordinates.adress,
				balloonContent: this.currentCordinates.adress
			});
			this.Ymap.geoObjects.add(myPlacemark);
		},
		getDomain: function getDomain(host) {
			var domains = this.domains;
			var cd;
			for (var i in domains) {
				if (domains[i].host == host) {
					cd = domains[i];
				}
			}
			return cd;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageContacts.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageContacts.vue
// module chunks = 0